import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ICountry } from '@app/models/addresses';
import { translate } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root'
})

export class SignupFormService {

  constructor(private http: HttpClient) {

  }

  private _countries: ICountry[] = [];

  get countries() {
    return this._countries;
  }

  set countries(countries: ICountry[]) {
    this._countries = countries;
  }

  private _phoneCountry: string;

  get phoneCountry() {
    return this._phoneCountry;
  }

  set phoneCountry(countryShort: string) {
    this._phoneCountry = countryShort;
  }

  getCountries(translated = false) {
    return this.http.get('/api/country?only_active=1').toPromise().then((result: any) => {
      const allCountries = result.data.map((country) => {
        if (translated) {
          const translatedName = translate(country.name);
          return {
            ...country,
            name: translatedName.toUpperCase()
          }
        } else {
          return country;
        }
      })

      const mainCountries: ICountry[] = [];
      const switzerland = allCountries.find((x: any) => x.short === 'CH');
      const france = allCountries.find((x: any) => x.short === 'FR');
      const germany = allCountries.find((x: any) => x.short === 'DE');
      const italy = allCountries.find((x: any) => x.short === 'IT');
      const belgium = allCountries.find((x: any) => x.short === 'BE');
      mainCountries.push(switzerland, france, germany, italy, belgium);

      let tmp: any[] = allCountries;
      tmp = tmp.filter(x => x !== switzerland && x !== france && x !== germany && x !== italy && x !== belgium);
      this.countries = mainCountries.concat(tmp);

      return true;
    }).catch(() => {

    });
  }

  getCurrentCountry(): ICountry {
    return (this.countries.find((cntry: { short: any }) => cntry.short === window['COUNTRY']) ||
            this.countries.find((cntry: { short: string }) => cntry.short === 'CH'));
  }

  getFilteredCountries(ev) {
    return this.countries.filter(value =>
          value.name.toLowerCase().indexOf(ev.toLowerCase()) > -1);
  }

  getCountryById(id): ICountry {
      return this.countries.find(res => res.id === id);
  }
}
